export const localStorageHelper = {
	isAvailable: (() => {
		try {
			if (typeof localStorage === "undefined") {
				return false;
			}

			const testKey = "__storage_test__";
			localStorage.setItem(testKey, testKey);
			localStorage.removeItem(testKey);
			return true;
		} catch (_e) {
			return false;
		}
	})(),

	getItem: (key: string, defaultValue = null) => {
		if (!localStorageHelper.isAvailable) {
			return defaultValue;
		}

		try {
			const item = localStorage.getItem(key);
			return item ? JSON.parse(item) : defaultValue;
		} catch (_e) {
			return defaultValue;
		}
	},

	setItem: (key: string, value: any): boolean => {
		if (!localStorageHelper.isAvailable) {
			return false;
		}

		try {
			localStorage.setItem(key, JSON.stringify(value));
			return true;
		} catch (_e) {
			return false;
		}
	},

	removeItem: (key: string): boolean => {
		if (!localStorageHelper.isAvailable) {
			return false;
		}

		try {
			localStorage.removeItem(key);
			return true;
		} catch (_e) {
			return false;
		}
	},

	clear: (): boolean => {
		if (!localStorageHelper.isAvailable) {
			return false;
		}

		try {
			localStorage.clear();
			return true;
		} catch (_e) {
			return false;
		}
	},

	clearExcept: (preservedPrefixes: string[]): boolean => {
		if (!localStorageHelper.isAvailable) {
			return false;
		}

		try {
			const keysToRemove: string[] = [];
			for (let i = 0; i < localStorage.length; i++) {
				const key = localStorage.key(i);
				if (key !== null && !preservedPrefixes.some((prefix) => key.startsWith(prefix))) {
					keysToRemove.push(key);
				}
			}
			for (const key of keysToRemove) {
				localStorage.removeItem(key);
			}
			return true;
		} catch (_e) {
			return false;
		}
	},
};
